import { Dispatch, SetStateAction } from 'react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Flex, Image, Box } from '@chakra-ui/react';
import { Text } from '../common/Text';
import { Button } from '../common/Button';
import { Step4 as PNG, Step4Content } from '../images/stepProgress/index';
import { MyModal } from '../common/MyModal';
import { DashboardStepProgressBar } from '../../components/common/DashboardStepProgressBar';

interface Props {
  setStep: Dispatch<SetStateAction<number>>;
}

export const Step4 = ({ setStep }: Props) => (
  <>
    <MyModal top="150px" left="50px">
      <Flex gap="20px" maxW="350px">
        <Flex direction="column" gap="30px" padding="20px 10px">
          <Flex gap="30px" align="center">
            <DashboardStepProgressBar text="4 z 6" image={PNG} />
          </Flex>
          <Text text="dashboardTutorial.step4" />
          <Flex gap="20px">
            <Button
              text="action.next"
              onClick={() => setStep((step: number) => step + 1)}
              variant="dasboardStep"
              rightIcon={<ChevronRightIcon w="7" h="7" />}
            />
          </Flex>
        </Flex>
      </Flex>
    </MyModal>
    <MyModal top="0px" left="100px" isOverlayed={false} isBackgroundTransparent>
      <Box>
        <Image src={Step4Content()} alt="alt.batteryStatus" maxW="100%" />
      </Box>
    </MyModal>
  </>
);
